var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1394_7986)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "url(#paint0_linear_1394_7986)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50468 4H6.37471L5.50218 6.3995H4L5.13288 4.22075C5.16745 4.15441 5.22054 4.09863 5.2862 4.05964C5.35186 4.02065 5.42751 4 5.50468 4ZM4.02994 7.19933L6.53691 10.9481L5.47973 7.19933H4.02994ZM6.34144 7.19933L7.61406 11.7144C7.63661 11.7963 7.68669 11.8687 7.7565 11.9203C7.8263 11.972 7.91191 12 8 12C8.08809 12 8.1737 11.972 8.2435 11.9203C8.31331 11.8687 8.36339 11.7963 8.38594 11.7144L9.66188 7.19933H6.34144ZM10.5236 7.19933L9.46392 10.9465L11.9701 7.19933H10.5228H10.5236ZM12 6.3995H10.5003L9.62695 4H10.4953C10.5726 3.99985 10.6485 4.02043 10.7143 4.05943C10.7801 4.09842 10.8333 4.15429 10.868 4.22075L12 6.3995ZM9.61946 6.3995H6.38386L7.25556 4H8.74444L9.61946 6.3995Z",
    fill: "url(#paint1_linear_1394_7986)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1394_7986",
    x: -70,
    y: -70,
    width: 156,
    height: 156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1394_7986"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1394_7986",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1394_7986",
    x1: 18.4,
    y1: -12.4,
    x2: -17.6,
    y2: 11.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.326096
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492411,
    stopColor: "#393737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609611
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1394_7986",
    x1: 6.92195,
    y1: 2.64354,
    x2: 7.91964,
    y2: 12.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC805"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9900"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.f81495c81278f02bc780847f0742e9ac.svg";
export { ForwardRef as ReactComponent };